import { apiClient } from '~services/apiClient'

interface ELID {
  companyId?: number
  dateOfBirth: string
  firstName: string
  lastName: string
  province?: string
  postalCode: string
}

interface EligibilityResponse {
  companyId: number
  success: boolean
}

/**
 * Fetch a user's record from the general eligibility endpoint
 */
export default function fetchCompanyEligibility(elid: ELID) {
  const url = '/b2b-user-onboarding/check-eligibility'
  return apiClient.put<EligibilityResponse>(url, {
    DOB: elid.dateOfBirth,
    firstName: elid.firstName,
    lastName: elid.lastName,
    ZIP: elid.postalCode,
    ...(!!elid.companyId && { companyId: elid.companyId.toString() }),
    ...(!!elid.province && { state: elid.province }),
  })
}
